/**
 * Created by Ray on 2017/8/21.
 */
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import 'rxjs/Rx';
import {Router} from '@angular/router';
import {Constants} from '../constants';
import {ProgressService} from './progress.service';
import {MsgService} from "./message.service";

@Injectable()
export class HttpService {

    constructor(private consts:Constants, private http:HttpClient, private progressService:ProgressService, private msgService:MsgService, private router:Router) {
    }

    public get(url, params?:HttpParams, callback?:Function, errorback?:Function) {
        const vm = this;
        vm.progressService.startProgress();
        vm.http.get(vm.consts.base_url_api + url, {'params': params})
            .subscribe(data => {
                vm.progressService.finishProgress();
                callback(data);
            }, error => {
                vm.progressService.finishProgress();
                if (errorback) {
                    errorback(error);
                }
            });
    }

    public post(url, params?, callback?:Function, errorback?:Function) {
        const vm = this;
        vm.progressService.startProgress();
        vm.http.post(vm.consts.base_url_api + url, params)
            .subscribe(data => {
                vm.progressService.finishProgress();
                callback(data);
            }, error => {
                vm.progressService.finishProgress();
                errorback(error);
            });
    }

    public auth_get(url, params?:HttpParams, callback?:Function, errorback?:Function) {
        const vm = this;
        vm.progressService.startProgress();
        const token = localStorage.getItem(this.consts.local_storage_token_name);
        let authHeader = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        vm.http.get(vm.consts.base_url_api + url, {params: params, headers: authHeader})
            .subscribe(data => {
                vm.progressService.finishProgress();
                callback(data);
            }, error => {
                vm.progressService.finishProgress();
                if (errorback) {
                    errorback(error);
                }
            });
    }

    public auth_post(url, params?, callback?:Function, errorback?:Function) {
        const vm = this;
        const token = localStorage.getItem(this.consts.local_storage_token_name);
        let authHeader = new HttpHeaders().set('Authorization', 'Bearer ' + token);
        vm.progressService.startProgress();
        vm.http.post(vm.consts.base_url_api + url, params, {headers: authHeader})
            .subscribe(data => {
                vm.progressService.finishProgress();
                callback(data);
            }, error => {
                vm.progressService.finishProgress();
                const errorCode = error.status;
                if (errorCode === 401) {
                    this.msgService.showError('Authentication Failed', 'You login timeout, please login.');
                    this.router.navigate(['/']);
                }
                if (errorback) {
                    errorback(error);
                }
            });
    }

}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/service/http.service.ts